module.exports = __webpack_public_path__ + "static/media/alarm1.b5237367.aac";